import { type FC } from 'react'

import {
  productAccessorGetBestSellerPromotionFromOffer,
  productAccessorIsSellerPromotionWithVoucherCode,
} from '../../../../product'
import { useProductPageContext } from '../../productPageContext'

import { ProductBuyBoxVoucherInfoSellerDiscount } from './components/ProductBuyBoxVoucherInfoSellerDiscount'
import { ProductBuyBoxVoucherInfoProduct } from './ProductBuyBoxVoucherInfoProduct'

export const ProductBuyBoxVoucherInfoSeller: FC = () => {
  const { currentOffer } = useProductPageContext()

  const sellerPromotion =
    productAccessorGetBestSellerPromotionFromOffer(currentOffer)

  if (
    !sellerPromotion ||
    !productAccessorIsSellerPromotionWithVoucherCode(sellerPromotion)
  ) {
    // Fallback to product promotion if possible
    return <ProductBuyBoxVoucherInfoProduct />
  }

  return (
    <ProductBuyBoxVoucherInfoSellerDiscount sellerPromotion={sellerPromotion} />
  )
}
